import React from 'react';
import { Container, Typography, Paper, Button } from '@mui/material';

const SupportCenter: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">Support Center</Typography>
                <Typography variant="body1" paragraph>
                    Need help? We are here for you.
                </Typography>

                <Typography variant="h6" gutterBottom>Common Questions</Typography>
                <Typography variant="body1" paragraph>
                    <strong>Q: How do I reset my password?</strong><br />
                    A: Please contact our support team at hello@studystride.app and we'll help you reset your password.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>Q: My progress isn't saving!</strong><br />
                    A: Please check your internet connection and try refreshing the page. If the issue persists, contact us.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>Q: How do I enroll in a course?</strong><br />
                    A: Log in to your account, navigate to your dashboard, and click "Register for Course" to browse available courses.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>Contact Support</Typography>
                <Typography variant="body1" paragraph>
                    If you can't find the answer you're looking for, please reach out to our team.
                </Typography>
                <Button variant="contained" color="primary" href="mailto:hello@studystride.app">Contact Us</Button>
            </Paper>
        </Container>
    );
};
export default SupportCenter;
